import AI_REDUX_CONSTANT from '../../constants/aiReduxConstant/AIReduxConstant';

const initialValue = {
    // Strategy state
    strategies: [],
    currentStrategy: null,
    isGeneratingPersonas: false,
    personasError: null,

    // Message state
    generatedMessages: null,
    isGeneratingMessage: false,
    messageError: null,
    messageHistory: null,
    messageStats: null,
};

const aiReducer = (state = initialValue, action) => {
    switch (action.type) {
        // Strategy cases
        case AI_REDUX_CONSTANT.SET_STRATEGIES:
            return {
                ...state,
                strategies: action.data,
            };

        case AI_REDUX_CONSTANT.SET_CURRENT_STRATEGY:
            return {
                ...state,
                currentStrategy: action.data,
                personasError: null,
            };

        case AI_REDUX_CONSTANT.SET_GENERATING_PERSONAS:
            return {
                ...state,
                isGeneratingPersonas: action.data,
            };

        case AI_REDUX_CONSTANT.SET_PERSONAS_ERROR:
            return {
                ...state,
                personasError: action.data,
                isGeneratingPersonas: false,
            };

        case AI_REDUX_CONSTANT.UPDATE_STRATEGY:
            return {
                ...state,
                currentStrategy: action.data,
                strategies: state.strategies.map((s) =>
                    s._id === action.data._id ? action.data : s
                ),
            };

        case AI_REDUX_CONSTANT.DELETE_STRATEGY:
            return {
                ...state,
                strategies: state.strategies.filter((s) => s._id !== action.data),
                currentStrategy: state.currentStrategy?._id === action.data ? null : state.currentStrategy,
            };

        // Message cases
        case AI_REDUX_CONSTANT.SET_GENERATED_MESSAGES:
            return {
                ...state,
                generatedMessages: action.data,
                messageError: null,
            };

        case AI_REDUX_CONSTANT.SET_GENERATING_MESSAGE:
            return {
                ...state,
                isGeneratingMessage: action.data,
            };

        case AI_REDUX_CONSTANT.SET_MESSAGE_ERROR:
            return {
                ...state,
                messageError: action.data,
                isGeneratingMessage: false,
            };

        case AI_REDUX_CONSTANT.SET_MESSAGE_HISTORY:
            return {
                ...state,
                messageHistory: action.data,
            };

        case AI_REDUX_CONSTANT.SET_MESSAGE_STATS:
            return {
                ...state,
                messageStats: action.data,
            };

        default:
            return state;
    }
};

export default aiReducer;
